import React from 'react';

import {BaseProps} from "../../../../infrastructure/models/props/base-props";
import {PlaceholderWrapperComponent} from "../../../../core/components/placeholder/placeholder-wrapper";
import {DeviceViewModel} from "../../../../core/models/device.view-model";
import {FormatListBulleted} from "../../../../core/icons/format-list-bulleted";

export class MyScoresWidgetCompetitionTitlePlaceholderProps extends BaseProps {
  device: DeviceViewModel;
}

export const MyScoresWidgetCompetitionTitlePlaceholder = (props: MyScoresWidgetCompetitionTitlePlaceholderProps) => {
  return (
    <PlaceholderWrapperComponent className={'my-scores-widget-placeholder-competition-title-container'}>
      <div className={'my-scores-widget-placeholder-competition-title-content'}>
        <div className={'my-scores-widget-placeholder-competition-title-center-container'}>
          <div className={'my-scores-widget-placeholder-competition-title-competition-logo'}/>
          <div className={'my-scores-widget-placeholder-competition-title-competition-and-country-container'}>
            <div className={'my-scores-widget-placeholder-competition-title-competition-name'}/>
            <div className={'my-scores-widget-placeholder-competition-title-country-name'}/>
          </div>
        </div>
        <FormatListBulleted className={'my-scores-widget-placeholder-competition-title-bullet'}/>
      </div>
    </PlaceholderWrapperComponent>
  )
}
